import React from 'react';
import { TextBlock } from 'react-placeholder/lib/placeholders';

const AnnoucmentPlaceholder = () => {
    return <div className='tb--placeholder tb--announcement-placeholder tb--flex tb--align-center tb--w_100 tb--show-animation'>
        <TextBlock className='tb--show-animation' />
    </div>
}
export default AnnoucmentPlaceholder